module.exports = __webpack_public_path__ + "static/media/Group 11094 (1).b9a7e76e.svg";